import { PaymentUtilService } from '@services/payment-util/payment-util.service';
import { inject, Component, Input } from '@angular/core';
import { NgIf } from '@angular/common';

@Component({
  selector: 'app-utm-wallet-hundred',
  templateUrl: './utm-wallet-hundred.component.html',
  styleUrls: ['./utm-wallet-hundred.component.scss'],
  standalone: true,
  imports: [NgIf]
})
export class UtmWalletHundredComponent {

  public paymentUtil = inject(PaymentUtilService);
  @Input() donation;
  @Input() type;


}
